import styled from "styled-components";
import { sizes } from "styles";

export const ClassReportCardContainer = styled.div<{ isWidthApplied: boolean }>`
  width: ${({ isWidthApplied }) =>
    isWidthApplied ? `${sizes.kelasLive.upcomingClassCardWidth}` : "auto"};
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  padding: 20px;
  box-shadow: 0px 0px 14px ${({ theme }) => theme.colors.transparent.white10};
`;

export const ClassReportCardMeta = styled.div`
  display: flex;
  align-items: self-start;
  justify-content: space-between;
`;

export const ClassReportCardAttendance = styled.div<{ classAttended: boolean }>`
  color: ${({ theme, classAttended }) =>
    classAttended ? theme.colors.green[600] : theme.colors.neutral[600]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  line-height: 1;
`;

export const ClassReportCardAttendanceMessage = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
  height: 21px;
  margin-top: 1px;
`;

export const ClassReportCardDetails = styled.div`
  padding: 0 0 16px 0;
`;
export const ClassReportCardDetailsHeading = styled.h3`
  margin: 8px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  width: 311px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ClassReportCardDetailsTeacher = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ClassReportCardInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ClassReportCardInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[600]};
    }
  }
`;

export const ClassReportCardFooter = styled.div`
  padding: 20px 0 0 0;
  border-top: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ClassReportCardMaterialInfo = styled.div`
  display: flex;
  align-items: center;
`;
